import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "../../css/estudiantes.css";
import {
    MDBBtn,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
  } from 'mdb-react-ui-kit';
import TeacherForm from '../../components/Forms/TeachersForm';
import Loading from '../../components/Loading';
import docentesService from "../../services/docentesService";
import Swal from "sweetalert2";
import useCustomDataTableStyles from "../../components/estilosDeDataTable";



const Docentes = () => {

  const [teachers, setTeachers] = useState([]); // Inicializa teachers como un array vacío
    
  
  const [fullscreenXlModal, setFullscreenXlModal] = useState(false);
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [filterText, setFilterText] = useState('');
  const [BtnVer, setBtnVer] = useState('');


  const toggleShow = () => {
      setFullscreenXlModal(!fullscreenXlModal);
      setSelectedTeacher(null); 
  };

  const openMaximizeModal = (teacher) => {
      setSelectedTeacher(teacher);
      setFullscreenXlModal(true);
      setBtnVer(true);
  };

  const openEditingModal = (teacher) => {
      setSelectedTeacher(teacher);
      setFullscreenXlModal(true);
      setBtnVer(false);
  };
  
  const openAddingModal = async (e) => {
    e.preventDefault(); // Añade esta línea para prevenir el comportamiento predeterminado del botón
    setSelectedTeacher(null); // Asegúrate de que no se pase ningún docente seleccionado
    setFullscreenXlModal(true);
    setBtnVer(false);
};

  const fetchTeachers = async () => {
    try {
        const response = await docentesService.getDocentes();
        if (response && response.length > 0) { // Asegurarse de que la respuesta contiene datos
            setTeachers(response);
        }
    } catch (error) {
        console.error("Error al obtener los docentes:", error);
    }
};

const deleteDocente = async(docente)=>{
  Swal.fire({
      title: 'Esta seguro que desea eliminar este docente?',
      text: "",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar!'
    }).then(async(result) => {
      if (result.isConfirmed) {
        try{
        await docentesService.deleteDocenteById(docente.teacherId);
        Swal.fire(
          'Felicidades!',
          'Docente eliminado exitosamente!',
          'success'
        );
        fetchTeachers();
        }catch(error){
          console.log(error);
          Swal.fire(
              "Ha ocurrido un error",
              "Por favor intentelo mas tarde",
              "error"
          );
        }
      }
    })
}


useEffect(() => {
    fetchTeachers();
  }, []);

  const columns = [
    { name: "ID", selector: "identification", sortable: true, grow:"2" },
    { name: "Nombre completo", selector: "fullName", sortable: true, grow:"8"  },
    { name: "Celular", selector: "cellPhone", sortable: true, grow:"3"  },
    { name: "Correo", selector: "email", sortable: true, grow:"4"  },
    { name: "Teléfono", selector: "phone", sortable: true, grow:"3"  },
    { name: "Dirección", selector: "address", sortable: true, grow:"4"  },
    { name: "Contrato", selector: "hireDate", sortable: true, grow:"3" },
    { name: "Acciones",
      grow:"2.5",
      selector: "actions",grow:"3",
      cell: (row) => (
        <div className="btn-group btn-group-sm">
          <button
            onClick={() => openMaximizeModal(row)}
            className="btn btn-outline-success me-1"
            title="Maximizar información"
          >
            <i className="fas fa-eye"></i>
          </button>
          <button
            onClick={() => openEditingModal(row)}
            className="btn btn-outline-info me-1"
            title="Editar"
          >
            <i className="icon-edit fas fa-pencil-alt"></i>
          </button>
          <button
            onClick={() => deleteDocente(row)}
            className="btn btn-outline-danger me-1"
            title="Eliminar"
          >
            <i className="icon-deactivate fas fa-times"></i>
          </button>
        </div>
      ),
    },
  ];

  const normalizeString = (str) => {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  };

  const filteredItems = teachers?.filter((item) => {
    if (item) {
      const allData = `${item.identification} ${item.fullName} ${item.cellPhone} ${item.email} ${item.phone} ${item.address} ${item.hiringDate}`;
      const normalizedFilterText = normalizeString(filterText);
      const normalizedItemName = normalizeString(allData);
      return normalizedItemName.includes(normalizedFilterText);
    }
    return item;
  });

  const customStyles = useCustomDataTableStyles();

  const paginationPerPage = 50; // Ajusta este número según tus necesidades

  return (
    <>
    <div className="card p-3">
        <div className="card-header">
        <h2 className="">Administración de docentes</h2>
        <h5 className="card-subtitle text-muted">Esta es la vista de los docentes de todo el plantel educativo.</h5>
      </div>

      <div className="card-body">
      <form className="row mb-3">
      <div className="col-md-8 col-xl-4 mb-md-0">
                        <input
                    type="text"
                    placeholder="Buscar docente"
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                    className="form-control "
                /></div>

                  <div className="col-md-4 col-xl-8 ">

                <div className="text-end">
                <button className="btn btn-primary" onClick={(e) => openAddingModal(e)}>
    <i className="fa-solid fa-circle-plus"></i> Nuevo docente
</button>                </div>
                </div>
                </form>
        </div>
        <DataTable
                className="students-datatable shadow-sm rounded"
                noDataComponent="No hay información que mostrar, por favor añadela"   
                columns={columns}
                data={filteredItems}
                pagination
                fixedHeader
                fixedHeaderScrollHeight="450px"
                customStyles={customStyles}
                paginationPerPage={paginationPerPage} // Agrega esta propiedad para controlar las filas por página
                paginationRowsPerPageOptions={[50, 100]}

            />
        <MDBModal tabIndex='-1' show={fullscreenXlModal} setShow={setFullscreenXlModal}>
                    <MDBModalDialog className="modal-xl-custom">
                        <MDBModalContent>
                            <MDBModalHeader>
                                <MDBModalTitle>DETALLES DEL DOCENTE</MDBModalTitle>
                                <MDBBtn
                                    type='button'
                                    className='btn-close'
                                    color='none'
                                    onClick={toggleShow}
                                ></MDBBtn>
                            </MDBModalHeader>
                            <MDBModalBody>
                                <div className='card'>
                                    {selectedTeacher && (
                                        <TeacherForm
                                            key={Date.now()}
                                            teacher={selectedTeacher.teacherId}
                                            onClose={() => {
                                                 setFullscreenXlModal(false); 
                                                 fetchTeachers();
                                            }}
                                            ReadOnly={BtnVer}
                                        />
                                    )}

                                    {!selectedTeacher && (
                                        <TeacherForm
                                            key={Date.now()}
                                            teacher={0}
                                            onClose={() => {
                                                 setFullscreenXlModal(false); 
                                                 fetchTeachers();
                                            }}
                                            ReadOnly={false}
                                        />
                                    )}
                                </div>
                            </MDBModalBody>
                            <MDBModalFooter>
                                <button type='button' className='btn-footer-close btn-primary' onClick={toggleShow}>
                                    Cerrar
                                </button>
                            </MDBModalFooter>
                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
                

    </div>
    </>
    );
};

export default Docentes;
